import { FullScreenSpinner } from "~/v2/components/common";
import { useLinkACHController } from "./LinkACH.controller";
import { LinkACHPresentation } from "./LinkACH.pres";

export const LinkACH = () => {
  const {
    status,
    isPlaidReady,
    isVerifyingMicroDeposit,
    showAlreadyLinked,
    isFullscreen,
    onOpenPlaid,
    onBack,
    isLoading,
    isRedirectingToOAuth,
  } = useLinkACHController();

  // Spinner while account/details/relationships load, or while bouncing an
  // errant OAuth return to the dedicated resume page.
  if (isLoading || isRedirectingToOAuth) {
    return <FullScreenSpinner />;
  }

  return (
    <LinkACHPresentation
      status={status}
      isPlaidReady={isPlaidReady}
      isVerifyingMicroDeposit={isVerifyingMicroDeposit}
      showAlreadyLinked={showAlreadyLinked}
      isFullscreen={isFullscreen}
      onOpenPlaid={onOpenPlaid}
      onBack={onBack}
    />
  );
};

export default LinkACH;
